import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["start", "end", "prefix", "unit", "speed", "decreasing", "onEnd", "className"];
import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import useInterval from '../../hooks/useInterval';
var TIMER = 10;
export var AnimatedNumber = /*#__PURE__*/forwardRef(function (props, ref) {
  var start = props.start,
    end = props.end,
    prefix = props.prefix,
    unit = props.unit,
    speed = props.speed,
    decreasing = props.decreasing,
    onEnd = props.onEnd,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(start),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  if (typeof start !== 'number' || typeof end !== 'number' || typeof speed !== 'number') {
    throw new Error('Props "start", "end" and "speed" need to be of type number.');
  }
  var shallContiueToRun = decreasing ? value > end : value < end;
  useInterval(function () {
    setValue(function (currentValue) {
      return decreasing ? currentValue - 1 : currentValue + 1;
    });
  }, shallContiueToRun ? speed : null);
  useEffect(function () {
    if (!shallContiueToRun) {
      onEnd();
    }
  });
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: ref
  }, remainingProps, {
    className: className
  }), "".concat(prefix).concat(value).concat(unit));
});
AnimatedNumber.defaultProps = {
  prefix: '',
  unit: '',
  speed: TIMER,
  decreasing: false,
  onEnd: function onEnd() {},
  className: ''
};
AnimatedNumber.propTypes = {
  start: PropTypes.number,
  end: PropTypes.number,
  prefix: PropTypes.string,
  unit: PropTypes.string,
  speed: PropTypes.number,
  decreasing: PropTypes.bool,
  onEnd: PropTypes.func,
  className: PropTypes.string
};
export default AnimatedNumber;